import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';

interface SummaryItem {
  label: string;
  value: string | number;
}

interface SummaryCardProps {
  title?: string;
  items: SummaryItem[];
  className?: string;
}

const SummaryCard = ({ title, items, className = '' }: SummaryCardProps) => {
  return (
    <Card className={className}>
      {title && (
        <CardHeader>
          <CardTitle className="text-lg">{title}</CardTitle>
        </CardHeader>
      )}
      <CardContent>
        <div className="bg-gray-50 rounded-lg p-2 space-y-2">
          {items.map((item, index) => (
            <div key={index} className="flex justify-between">
              <span className="text-sm text-gray-600">{item.label}:</span>
              <span className="text-sm font-medium">{item.value}</span>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};

export default SummaryCard;
